import { useGetSurveyByIdReturnData } from '@/lib/useQuery/survey/useGetSurveyById';
import * as Sentry from '@sentry/react';
export function setSurveyContext(survey?: useGetSurveyByIdReturnData | null) {
    const scope = Sentry.getCurrentScope();
    if (survey) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { ...surveyData } = survey;
        scope.setTag("surveyId", survey.id);
        scope.setContext("survey", { ...surveyData });
    } else {
        scope.clear();
    }
}